import React, { useCallback, useEffect, useState } from "react";
import { decideSignupRequest, fetchPendingSignupRequests } from "../api/client";

const REVIEW_ROLES = ["CLIENT", "TRAINER", "RECEPTIONIST", "MANAGER"];

export default function PendingSignups() {
  const [requests, setRequests] = useState([]);
  const [roles, setRoles] = useState({});
  const [busyId, setBusyId] = useState("");
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    try {
      setRequests(await fetchPendingSignupRequests());
      setError("");
    } catch (err) {
      setError(err.message || "Pending signups are unavailable.");
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const decide = async (item, decision) => {
    setBusyId(item.request_id);
    setError("");
    try {
      await decideSignupRequest(item.request_id, decision, roles[item.request_id] || "CLIENT");
    } catch (err) {
      setError(err.message || "The signup decision could not be recorded.");
    }
    await refresh();
    setBusyId("");
  };

  return (
    <section className="studio-panel iam-pending-panel" aria-labelledby="iam-pending-title">
      <div className="studio-panel-header">
        <div>
          <div className="studio-eyebrow">MEMBERSHIP</div>
          <h2 id="iam-pending-title">
            Pending signups ({requests.length})
          </h2>
        </div>
        <button className="studio-btn-ghost" type="button" onClick={refresh}>Refresh</button>
      </div>
      {error && <p className="studio-alert studio-alert-attention" role="alert">{error}</p>}
      {!requests.length && !error && <p className="studio-muted">There are no signup requests awaiting review.</p>}
      {requests.map((item) => (
        <article className="iam-pending-row" key={item.request_id}>
          <div><strong>{item.display_name}</strong><div className="studio-muted">{item.login}</div></div>
          <label>
            <span className="visually-hidden">Approved role for {item.display_name}</span>
            <select value={roles[item.request_id] || "CLIENT"}
              onChange={(event) => setRoles((current) => ({ ...current, [item.request_id]: event.target.value }))}
              disabled={busyId === item.request_id}>
              {REVIEW_ROLES.map((role) => <option key={role} value={role}>{role}</option>)}
            </select>
          </label>
          <div className="iam-pending-actions">
            <button type="button" className="studio-btn-primary" disabled={!!busyId} onClick={() => decide(item, "APPROVE")}>
              {busyId === item.request_id ? "Saving…" : "Approve"}
            </button>
            <button type="button" className="studio-btn-ghost" disabled={!!busyId} onClick={() => decide(item, "REJECT")}>Reject</button>
          </div>
        </article>
      ))}
    </section>
  );
}
